<div class="db-contact-us db-panel db-panel_flex">
  <div dbCustomScrollbar class="db-panel__body">
    <div class="db-contact-us__form">
      <h1>{{'text_contactUsTitle' | dbText}}</h1>
      <form [formGroup]="contactUsForm" (ngSubmit)="onFormSubmit()">
        <div class="contact-us__notification">
          <div class="contact-us__icon-wrap">
            <img src="assets/images/icons/support.svg" alt="">
          </div>
          <div class="contact-us__text-wrap" [innerHTML]="'text_contactUsDesc' | dbText"></div>
        </div>
        <div class="contact-us__item">
          <div class="db-server-error" *ngIf="serverErrors && serverErrors.message">{{serverErrors.message}}</div>
        </div>
        <div class="contact-us-body">
          <div class="contact-us__item">
            <input class="db-fc-input" placeholder="Full name" type="text" name="name" id="name" formControlName="fullName">
            <div class="db-server-error-wrap">
            </div>
          </div>
          <div class="contact-us__item">
            <input class="db-fc-input" type="email" name="email" maxlength="100" placeholder="Email address" required [style.border-color]="(contactUsForm.controls['email'].invalid && ((contactUsForm.controls['email'].touched && !contactUsForm.controls['email'].errors['required']) || formSubmitted) || (serverErrors && serverErrors.message)) ? '#E95E5B' : null" formControlName="email"  x-autocompletetype="email">
            <div class="db-server-error-wrap">
              <div *ngIf="(contactUsForm.controls['email'].invalid && ((contactUsForm.controls['email'].touched && !contactUsForm.controls['email'].errors['required']) || formSubmitted))">{{'text_invalidEmail' | dbText}}</div>
              <div *ngIf="serverErrors && serverErrors.fields.email">{{serverErrors.fields.email[0]}}</div>
            </div>
          </div>
          <div class="dropdown-wrap">
            <div class="contact-us__item" [ngClass]="{'contact-us__item-split': inquiryType.value === 'customerServiceSupport'}">
              <div class="dropdown-container">
                <db-fc-dropdown-select [formControl]="inquiryType" [value]="inquiryType.value" [options]="inquiryTypeOptions"></db-fc-dropdown-select>
              </div>
            </div>

            <div class="contact-us__item contact-us__item-split" *ngIf="inquiryType.value === 'customerServiceSupport'">
              <div class="dropdown-container">
                <db-fc-dropdown-select [formControl]="customerServiceSupport" [value]="customerServiceSupport.value" [options]="customerServiceSupportOptions"></db-fc-dropdown-select>
              </div>
            </div>
          </div>
          <div class="contact-us__item">
            <input class="db-fc-input" placeholder="Subject" type="text" name="subject" id="subject" formControlName="subject">
            <div class="db-server-error-wrap">
            </div>
          </div>

          <div class="contact-us__item">
            <textarea name="message" placeholder="Message" id="message" formControlName="message" [style.border-color]="(contactUsForm.controls['message'].invalid && ((contactUsForm.controls['message'].touched && !contactUsForm.controls['message'].errors['required']) || formSubmitted) || (serverErrors && serverErrors.message)) ? '#E95E5B' : null"></textarea>
            <div class="db-server-error-wrap">
              <div *ngIf="(contactUsForm.controls['message'].invalid && ((contactUsForm.controls['message'].touched && !contactUsForm.controls['message'].errors['required']) || formSubmitted))">{{'text_emptyMessage' | dbText}}</div>
              <div *ngIf="serverErrors && serverErrors.fields.message">{{serverErrors.fields.message[0]}}</div>
            </div>
          </div>
        </div>
        <div class="contact-us__button-wrap">
          <a class="db-button db-button_lg db-button_info" [ngClass]="{'db-button_disabled' : loading}" (click)="onFormSubmit()">
            <span *ngIf="!loading" >{{'text_sendMessage' | dbText}}</span>
            <db-loading-circular-spinner *ngIf="loading"></db-loading-circular-spinner>
          </a>
        </div>
      </form>
    </div>
  </div>
</div>
